export interface EntryResponse {
  id: string
  painterName: string
  blobUrl: string
  status: 'PENDING' | 'APPROVED' | 'REJECTED'
  displayOrder: number | null
  submittedAt: string
  reviewedAt: string | null
}

export interface SettingsResponse {
  slideDurationSeconds: number
  painterUrl: string
  autoApprove: boolean
}

async function jsonFetch<T>(input: RequestInfo, init?: RequestInit): Promise<T> {
  const response = await fetch(input, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...init,
  })
  if (!response.ok) {
    throw new Error(`Request failed (${response.status}): ${await response.text()}`)
  }
  return (await response.json()) as T
}

export const api = {
  login(password: string) {
    return jsonFetch<{ ok: boolean }>('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ password }),
    })
  },
  logout() {
    return jsonFetch<{ ok: boolean }>('/api/auth/logout', { method: 'POST' })
  },
  me() {
    return jsonFetch<{ authenticated: boolean }>('/api/auth/me')
  },
  entriesTonight() {
    return jsonFetch<EntryResponse[]>('/api/entries/tonight')
  },
  entriesDisplay() {
    return jsonFetch<EntryResponse[]>('/api/entries/display')
  },
  updateEntry(id: string, body: { status?: string; displayOrder?: number | null }) {
    return jsonFetch<EntryResponse>(`/api/entries/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    })
  },
  getSettings() {
    return jsonFetch<SettingsResponse>('/api/settings/')
  },
  updateSettings(body: { slideDurationSeconds?: number; newPassword?: string; autoApprove?: boolean }) {
    return jsonFetch<SettingsResponse>('/api/settings/', {
      method: 'PATCH',
      body: JSON.stringify(body),
    })
  },
}
